<template>
  <div>
    <b-card :title="$t('dashboard.usage.title')">
      <b-row>
        <b-col
          cols="12"
          md="8"
        >
          <b-row>
            <b-col
              cols="12"
              md="auto"
            >
              <div class="border-right pr-5">
                <div class="font-weight-bold text-primary">
                  {{ $t('dashboard.usage.package') }}
                </div>
                <div class="font-weight-bold font-medium-2">
                  {{ packageData.package_name }}
                </div>
              </div>
            </b-col>
            <b-col
              cols="12"
              md="auto"
            >
              <div class="border-right pr-5">
                <div class="font-weight-bold text-primary">
                  {{ $t('dashboard.usage.userLicense') }}
                </div>
                <div class="font-weight-bold font-medium-2">
                  {{ $t('dashboard.usage.userCount', { count: packageData.users }) }}
                </div>
              </div>
            </b-col>
            <b-col
              cols="12"
              md="auto"
            >
              <div class="pr-5">
                <div class="font-weight-bold text-primary">
                  {{ $t('dashboard.usage.expiration') }}
                </div>
                <div class="font-weight-bold font-medium-2">
                  {{ moment(packageData.expiration).format('DD.MM.YYYY') }}
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <div>
            <div class="font-weight-bold text-primary">
              {{ $t('dashboard.usage.diskUsage') }}
            </div>
            <div>
              <b-progress
                class="custom-progress"
                height="25px"
                :variant="packageData.diskUsage.variant"
              >
                <b-progress-bar
                  :value="packageData.diskUsage.usage"
                  :max="packageData.diskUsage.limit"
                >
                  <span class="progress-text">{{ $t('common.percent', { value: packageData.diskUsage.percent }) }}</span>
                </b-progress-bar>
              </b-progress>
              <div class="d-flex align-items-center justify-content-between text-muted font-small-2">
                <div>{{ packageData.diskUsage.usage | toNumber }} MB</div>
                <div>{{ packageData.diskUsage.limit | toNumber }} MB</div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BRow, BCol, BProgressBar, BProgress,
} from 'bootstrap-vue'

export default {
  name: 'UsageCard',
  components: {
    BCard,
    BRow,
    BCol,
    BProgress,
    BProgressBar,
  },
  computed: {
    packageData() {
      return this.$store.getters['dashboard/package']
    },
  },
}
</script>
<style scoped>
.custom-progress {
  position: relative;
}

.custom-progress .progress-text {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 1;
  color: #666666;
  font-weight: bold;
}

.dark-layout .custom-progress .progress-text {
  color: #d0d2d6;
}
</style>
